export type { ComponentPropsWithoutRef } from 'react'
import React from 'react'

type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  variant?: 'default' | 'secondary' | 'outline' | string
}

export function Badge(props: BadgeProps) {
  const { className = '', variant, ...rest } = props
  const variantClass = variant === 'outline'
    ? 'border border-current'
    : variant === 'secondary'
      ? 'bg-gray-200 text-gray-800'
      : 'bg-gray-900 text-white'
  return <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${variantClass} ${className}`} {...rest} />
}
